module.exports = __webpack_public_path__ + "img/group_remove_opsz24B.e69e7eda.svg";